import { render, staticRenderFns } from "./ReviewAdd.vue?vue&type=template&id=4929d9c2"
import script from "./ReviewAdd.vue?vue&type=script&lang=js"
export * from "./ReviewAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports